<template>
  <div class="page_content">
    
    <div class="row page-heading mx-0">
      <div class="col-8 input module_heading">
        <span class="module_icon icon-link"></span>
        <span class="module_type_name">Quick Link Management</span>
      </div>
      <div class="col-4 submit btn-container text-right">
        <button type="button" class="btn btn-primary" @click.prevent="save" aria-label="save">save</button>
        <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
      </div>
    </div>
    <div class="content-section-with-bg-brdr">
      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="title">Title <sup>*</sup></div>
          <div class="col-8">
            <b-form-input v-model.trim="title" :state="titleState"
              aria-labelledby="title" placeholder="Title"
              aria-describedby="titleFeedback" v-focus>
            </b-form-input>
            <b-form-invalid-feedback id="titleFeedback">
              Title must not be empty
            </b-form-invalid-feedback>
          </div>
        </div>
      </div>
      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="url">Url <sup>*</sup></div>
          <div class="col-8">
            <b-form-input v-model.trim="uri" :state="urlState"
              aria-labelledby="url" placeholder="http://"
              aria-describedby="urlFeedback">
            </b-form-input>
            <b-form-invalid-feedback id="urlFeedback">
              URL must be valid
            </b-form-invalid-feedback>
          </div>
        </div>
      </div>
      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="url">Icon Url</div>
          <div class="col-8">
            <b-form-input v-model.trim="icon"
              aria-labelledby="icon" placeholder="http://" >
            </b-form-input>
          </div>
        </div>
      </div>
      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label" id="url">Type <sup>*</sup></div>
          <div class="col-8">
            <select class="form-control" v-model="type" style="width: 38%; height: 30px !important;">
              <option v-for="option in typeOptions" v-bind:value="option" >{{ option }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row field-row">
        <div class="col-11 row">
          <div class="col-2 form-label">
            <label for="order" id="numOrder">Order <sup>*</sup></label>
          </div>
          <div class="col-1" :class="{error: (newOrder < 1 || newOrder > maxOrder)}">
            <input
              type="number"
              id="order"
              aria-labelledby="numOrder"
              min="1"
              :max="maxOrder"
              v-model.number="newOrder"
              style="width: 50px; height: 33px;">
          </div>
          <div class="error" style="margin-top: 6px;" v-if="(newOrder < 1 || newOrder > maxOrder)">Order must be between 1 and {{maxOrder}}</div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, url} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'quickLinkCreate',
    props: ['uuid', 'title', 'uri', 'order', 'maxOrder', 'icon', 'placement', 'type'],
    data: (vm) => {
      return {
        typeOptions: ['QUICKLINK', 'SOCIALMEDIA', 'MENU'],
        newOrder: vm.order,
        type:'QUICKLINK'
      }
    },
    validations: {
      title: {
        required
      },
      uri: {
        required,
        url
      }
    },

    computed: {
      titleState () {
        return !this.$v.title.$error
      },
      urlState () {
        return !this.$v.uri.$error
      }
    },

    methods: {
      ...mapActions([
        'createQuickLink'
      ]),

      cancel () {
        this.$router.go(-1)
      },

      save () {
        this.$v.uri.$touch()
        this.$v.title.$touch()
        if (this.titleState && this.urlState && !(this.newOrder < 1 || this.newOrder > this.maxOrder)) {
          this.$refs.loadingModal.show()
          let quickLink = {
            url: this.uri,
            title: this.title,
            order: this.newOrder,
            type: this.type,
            icon:this.icon,
            placement:this.placement,
            icon:this.icon
          }
          let text = 'Quick Link "' + this.title + '" created successfully.'
          if (this.uuid) {
            quickLink.uuid = this.uuid
            text = 'Quick Link "' + this.title + '" updated successfully.'
          }
          this.createQuickLink(quickLink).then(res => {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: text
            })
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              return this.$router.push({name: 'quickLinkList'})
            }, 500)
          })
        }
      }
    }
  }
</script>

<style scoped>
  sup {
    color: red;
  }
  .error {
    color: #f57f6c;
  }
</style>



// WEBPACK FOOTER //
// src/app/quickLink/components/QuickLinkCreate.vue